import { Button, cardClass } from '@ledgerloom/ui';
import { useEffect, useState, type FormEvent } from 'react';
import { api, ApiError, type Me } from '../api';
import { ErrorBanner } from '../components/ui';
import { Field } from '../components/Field';
import { PasswordInput } from './Login';

// Signed in with the temporary password from the welcome email: a password of
// your own comes before anything else. Patterns: forms/password and
// authentication/password-reset (a new password, confirmed).
export function SetPassword({ me, onDone, onSignOut }: { me: Me; onDone: (me: Me) => void; onSignOut: () => void }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  useEffect(() => { document.title = 'Choose your password · Mazu'; }, []);

  const short = next.length > 0 && next.length < 12;
  const mismatch = confirm.length > 0 && confirm !== next;
  const wrongCurrent = error instanceof ApiError && error.code === 'wrong_password';

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (next.length < 12 || next !== confirm) return;
    setBusy(true); setError(null);
    try {
      await api('/v1/me/password', { body: { current_password: current, new_password: next } });
      onDone(await api<Me>('/v1/me'));
    } catch (err) { setError(err); } finally { setBusy(false); }
  }

  return (
    <main className="login" id="main">
      <div className="stack login-col">
        <form className={`${cardClass} card-pad stack`} onSubmit={submit} noValidate>
          <div className="row"><img src="/icon.svg" alt="" width={32} height={32} /><h1>Choose your password</h1></div>
          <p className="muted" style={{ margin: 0 }}>Welcome to {me.tenant_name}. You signed in with a temporary password; choose your own to go on.</p>
          <ErrorBanner error={wrongCurrent ? null : error} focusOnShow />
          <Field label="Temporary password" hint="The one in your welcome email." error={wrongCurrent ? 'That is not the temporary password.' : null} required>
            <PasswordInput value={current} onChange={setCurrent} show={show} onToggle={() => setShow((v) => !v)} />
          </Field>
          <Field label="New password" hint="At least 12 characters." error={short ? 'Use at least 12 characters.' : null} required>
            <PasswordInput value={next} onChange={setNext} show={show} onToggle={() => setShow((v) => !v)} autoComplete="new-password" />
          </Field>
          <Field label="New password again" error={mismatch ? 'The two passwords do not match.' : null} required>
            <PasswordInput value={confirm} onChange={setConfirm} show={show} onToggle={() => setShow((v) => !v)} autoComplete="new-password" />
          </Field>
          <Button type="submit" disabled={busy || next.length < 12 || next !== confirm || !current}>{busy ? 'Saving…' : 'Save and continue'}</Button>
          <Button type="button" variant="ghost" size="sm" style={{ alignSelf: 'flex-start', paddingLeft: 0 }} onClick={onSignOut}>Sign out</Button>
        </form>
      </div>
    </main>
  );
}
